import {useCallback, type Ref} from 'react';
import {useTranslation} from 'react-i18next';
import {FormProvider} from 'react-hook-form';
import {WhosComingForm} from 'components/ReservationSettingsModal';
import {useGuestCountSubmit} from 'pages/Auth/hooks/useGuestCountSubmit';
import {PropertyLinkShell} from 'pages/SearchReservation/components/PropertyLinkShell';
import {SignedInAs, StepHeading} from './StepParts';

type Props = {
  columnRef: Ref<HTMLDivElement>;
  onDone: () => void;
};

function CountStep({columnRef, onDone}: Props) {
  const {t} = useTranslation();
  const handleDone = useCallback(() => onDone(), [onDone]);
  const {formMethods, onSubmit, formProps} = useGuestCountSubmit({onDone: handleDone});

  return (
    <PropertyLinkShell columnRef={columnRef}>
      <SignedInAs />
      <StepHeading lead={t('guest_count_check_lead')}>
        {t('instant_check_in.confirm_whos_coming')}
      </StepHeading>

      <FormProvider {...formMethods}>
        <WhosComingForm
          {...formProps}
          onSubmit={onSubmit}
          className="-mb-6 flex flex-1 flex-col desk:mb-0"
          stickySubmit
        />
      </FormProvider>
    </PropertyLinkShell>
  );
}

export {CountStep};
